import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Col, Row } from "react-bootstrap";
import { ILicenceTransferDetails } from "../../../api/ILicenceTransfer";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";

interface LicenceTransferDetailsProps {
  licenceTransferDetails: ILicenceTransferDetails;
}

const LicenceTransferDetails = ({
  licenceTransferDetails,
}: LicenceTransferDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Proposed Transferee"}
            value={licenceTransferDetails.proposedtransfereeorganisationname}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Application Received Date"}
            value={licenceTransferDetails.validapplicationreceiveddate}
          />
          <EpaField
            label={"Transfer Date"}
            value={licenceTransferDetails.licencetransferdate}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col col-md-12">
          <EpaField
            label={"Transfer Request Reason"}
            value={licenceTransferDetails.transferrequestreason}
            labelClassName="col-2 col-md-2" // narrower label
            valueClassName="col-10 col-md-10 text-start d-block"
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Transfer Request Details"} content={bodyElements} />;
};

export default LicenceTransferDetails;
